module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/nailCare_7767a9.png";